import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";

const SUB_TABS = [
  { id: "generate", path: "/rubrics/generate", icon: "fa-regular fa-comment", label: "Generate" },
  { id: "edit", path: "/rubrics/edit", icon: "fa-solid fa-pen-to-square", label: "Edit" },
  { id: "saved", path: "/rubrics/saved", icon: "fa-regular fa-bookmark", label: "Saved" },
];

function getActiveSubTab(pathname) {
  if (pathname.includes("/edit")) return "edit";
  if (pathname.includes("/saved")) return "saved";
  return "generate";
}

export default function RubricsLayout() {
  const location = useLocation();
  const activeSubTab = getActiveSubTab(location.pathname);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: 0,
      position: "absolute",
      top: "var(--header-height)",
      left: 0,
      right: 0,
      bottom: 0,
      height: "calc(100vh - var(--header-height))"
    }}>
      {/* Sub-tab Menu Bar */}
      <div className="subnav">
        {SUB_TABS.map((tab) => (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={`subnav-tab ${activeSubTab === tab.id ? "active" : ""}`}
          >
            <i className={tab.icon}></i>{tab.label}
          </NavLink>
        ))}
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, overflow: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}
